<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{'manage_users' | translate}}</h3>
          </div>
          <div class="box-body">
            <div class="row pb-10 pt-10">
              <div class="col-sm-6">
                <h3
                  class="box-title"
                  style="margin-top: 0px;"
                >
                  {{user.first_name}}&nbsp;{{user.last_name}}
                </h3>
                <p><span class="text-muted">{{'username' | translate}}:&nbsp;</span>{{user.username}}</p>
                <p><span class="text-muted">{{'email' | translate}}:&nbsp;</span>{{user.email}}</p>
              </div>
              <div class="col-sm-6 text-right text-center-xs">
                <button
                  class="btn btn-info btn-app"
                  type="button"
                  data-toggle="collapse"
                  data-target="#editUser"
                  aria-expanded="false"
                  aria-controls="editUser"
                >
                  <i class="fa fa-edit"></i>{{'edit' | translate}}
                </button>
              </div>
            </div>
            <div class="collapse" id="editUser">
              <hr>
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="first_name">{{'first_name' | translate}}:</label>
                    <input
                      v-validate="'required'"
                      :data-vv-as="'first_name' | translate"
                      class="form-control"
                      name="first_name"
                      :placeholder="'first_name' | translate"
                      type="text"
                      v-model="user.first_name"
                    >
                    <span v-show="errors.has('first_name')" class="small text-danger">{{ errors.first('first_name') }}</span>
                  </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="last_name">{{'last_name' | translate}}:</label>
                    <input
                      v-validate="'required'"
                      :data-vv-as="'last_name' | translate"
                      class="form-control"
                      name="last_name"
                      :placeholder="'last_name' | translate"
                      type="text"
                      v-model="user.last_name"
                    >
                    <span v-show="errors.has('last_name')" class="small text-danger">{{ errors.first('last_name') }}</span>
                  </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="name">{{'username' | translate}}:</label>
                    <input type="text" class="form-control" id="name" v-model="user.username" disabled>
                  </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="email">{{'email' | translate}}:</label>
                    <input type="email" class="form-control" id="email" v-model="user.email" disabled>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-xs-6">
                  <button
                    class="btn btn-app btn-outline no-margin"
                    type="button"
                    data-toggle="collapse"
                    data-target="#editUser"
                    aria-expanded="false"
                    aria-controls="editUser"
                  >
                    <i class="fa fa-times"></i>{{'cancel' | translate}}
                  </button>
                </div>
                <div class="col-xs-6 text-right">
                  <button :disabled="errors.any()" @click="postData" class="btn btn-app btn-success">
                    <i class="fa fa-save"></i>{{'submit' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Users',
  data () {
    return {
      showDismissibleAlert: false,
      user: this.$store.getters.user,
      translate: this.$parent.translate,
      alerts: []
    }
  },
  methods: {
    postData () {
      let updateUser = { 'first_name': this.user.first_name, 'last_name': this.user.last_name }
      API.put('/accounting/user', updateUser)
        .then(response => {
          let alert = {type: 'success', dismiss: 4, message: 'Successfully edited user'}
          this.$store.commit('pushAlert', alert)
          this.$store.commit('updateUser', updateUser)
        })
        .catch(error => {
          if (this.$store.dispatch('checkError', error)) {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          } else this.$router.push('/unauthorized')
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Users.vue